<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        block
        v-on="on"
      >
        Create Education Institutes
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Education Institutes"
      text="Create Education Institutes"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="country"
                v-validate="'required'"
                :error-messages="errors.collect('country')"
                data-vv-name="country"          
                :items="countries"
                item-text="name"
                outlined
                item-value="id"
                label="Country"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="px-10 white--text"       
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        countries: [],
        country: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
        this.loadCountries()
      },
    },
    methods: { 
      prepareFormData () {
        return {
          name: this.name,
          country_id: this.country,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.hrisEducationInstitutes().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new education institution' })

                  this.progressing = false
                  this.dialog = false            
                }
              })
          })
      },
      loadCountries () {
        this.$api.countries().list()
          .then(res => {
            this.countries = _.orderBy(res.data, ['name'], ['asc'])
          })
      },
 
      resetForm () {
        this.$validator.reset()
        this.name = null
        this.country = null
      },
    },
  }
</script>
